export default "__VITE_ASSET__CUfAeoT1__"